
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.461 6.77a1.23 1.23 0 100-2.462 1.23 1.23 0 000 2.461z","fill":"currentColor"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.847 3.693c0-1.02.826-1.846 1.846-1.846h8.614c1.02 0 1.846.826 1.846 1.846v8.614c0 1.02-.826 1.846-1.846 1.846H3.693a1.846 1.846 0 01-1.846-1.846V3.693zm1.846-.615h8.614c.34 0 .615.275.615.615v8.614c0 .14-.046.27-.125.373a.993.993 0 00-.062-.073L7.12 6.48a1.846 1.846 0 00-2.78.066L3.079 8.062v-4.37c0-.339.275-.614.615-.614zm-.615 6.906v2.323c0 .34.275.615.615.615h7.663l-5.144-5.61a.615.615 0 00-.926.022l-2.208 2.65z","fill":"currentColor"}})])
          )
        }
      }
    